module.exports = __webpack_public_path__ + "static/03-6f59e15c09e3a4b7671bcbc0bcce544c.jpg";